<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

<div class="file-upload-box-container" [ngClass]="{'container-file-selected': file}">
  <div class="file-upload-box">
    @if (!file) {
      <label for="theFile">
        @if (!file) {
          <span class="material-symbols-outlined">upload_file</span>
          <div>{{instruction}}</div>
          <div>or</div>
        }
      </label>
    }
    @if (file) {
      <div class="file-selected"><b>Selected: </b>{{file.name}}</div>
    }
    <div class="btn" >Browse</div>
    <input #fileDropInput (change)="handleFileInput($event.target); preview=null" id="theFile" name="file" type="file">
  </div>

</div>
